import { render, staticRenderFns } from "./asgctPC.vue?vue&type=template&id=b63d2df4&scoped=true"
import script from "./asgctPC.vue?vue&type=script&lang=js"
export * from "./asgctPC.vue?vue&type=script&lang=js"
import style0 from "./asgctPC.vue?vue&type=style&index=0&id=b63d2df4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63d2df4",
  null
  
)

export default component.exports